/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Styles for the three-dot action menu.
 *
 * @file threeDotActionMenuStyles.js
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import { styled } from '@mui/material/styles';
import mixins from '../../assets/styles/mixins.scss';
import { createScopedClasses, createScopedStyles } from '../../assets/styles/createScopedStyles';

const threeDotActionMenuStyles = {
  menuWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    minHeight: 40
  },
  menuIconButton: {
    width: 24,
    height: 24,
    minWidth: 24,
    padding: 4,
    flexShrink: 0,
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: mixins.lightGreyBgColor
    },
    '& > span, & svg': {
      width: 16,
      height: 16
    }
  },
  activeMenuIcon: {
    transform: 'rotate(-90deg)'
  },
  menuIconButtonDisabled: {
    opacity: 0.38,
    cursor: 'default',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  menuPaper: {
    borderRadius: 8,
    minWidth: 200,
    boxShadow: `0 1px 14px ${mixins.color_elevation_alpha_04}, 0 5px 8px ${mixins.color_elevation_alpha_08}, 0 3px 5px -1px ${mixins.color_elevation_alpha_12}`
  },
  menuList: {
    padding: 0
  },
  menuItem: {
    padding: 8,
    '& p': {
      color: mixins.timeIconColor,
      fontFamily: mixins.fontFamilyPlusSans,
      fontSize: 14,
      lineHeight: '22px'
    },
    '&:hover': {
      backgroundColor: mixins.lightGreyBgColor
    }
  },
  menuItemDivider: {
    borderTop: `1px solid ${mixins.color_elevation_alpha_12}`
  },
  menuItemDisabled: {
    opacity: 0.38,
    cursor: 'default',
    pointerEvents: 'none',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
};

export const classes = createScopedClasses('aet-three-dot-action-menu', threeDotActionMenuStyles);

export const scopedStyles = createScopedStyles(threeDotActionMenuStyles, classes);

export const ThreeDotActionMenuStylesRoot = styled('div')(scopedStyles);

export default threeDotActionMenuStyles;
